import client from "./client";

export interface ProfileResponse {
  id: string;
  email: string;
  name: string | null;
  role: string;
  company_name: string | null;
  logo_url: string | null;
  contact_email: string | null;
  phone: string | null;
  company_website: string | null;
  subscription_active: boolean;
  survey_credits: number;
}

interface LogoPresignResponse {
  upload_url: string;
  s3_key: string;
}

export async function getProfile(): Promise<ProfileResponse> {
  const { data } = await client.get<ProfileResponse>("/v1/profile");
  return data;
}

export async function updateProfile(params: {
  company_name?: string;
  logo_s3_key?: string;
  contact_email?: string;
  phone?: string;
  company_website?: string;
}): Promise<ProfileResponse> {
  const { data } = await client.put<ProfileResponse>("/v1/profile", params);
  return data;
}

export async function getLogoPresignedUrl(
  filename: string,
  contentType: string,
): Promise<LogoPresignResponse> {
  const { data } = await client.post<LogoPresignResponse>(
    "/v1/profile/logo-presign",
    { filename, content_type: contentType },
  );
  return data;
}

export async function uploadLogoToS3(url: string, file: File): Promise<void> {
  const response = await fetch(url, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": file.type },
  });
  if (!response.ok) {
    throw new Error(`S3 upload failed: ${response.status} ${response.statusText}`);
  }
}
